
function HitCount(Action) {
    var ProductHitData = null;
    ProductHitData = {
        Action: Action
    };
    var objAjax = {};
    objAjax.url = SaaS_Analytics_Microservice_URL + 'api/PageHits';
    objAjax.type = 'POST';
    objAjax.data = JSON.stringify(ProductHitData);
    objAjax.headers = { "LanguageGuid": languageuid, "WebsiteGuid": websiteguid, "Cookiedetails": cookiedetails, "SessionGuid": SessionGuid  };
    objAjax.OnSuccess = function (data) {
        console.log('ProductHitDone');
    };
    objAjax.OnError = function (msg) {
       
    };
    objAjax.isAsync = false;
    objAjax.MicroserviceName = 'SaaS_Analytics_Microservice';
    objAjax.contentType = 'application/json;charset=utf-8';

    callApi(objAjax);

    //$.ajax({
    //    url: SaaS_Analytics_Microservice_URL + 'api/PageHits',
    //    type: 'POST',
    //    data: JSON.stringify(ProductHitData),
    //    contentType: "application/json;charset=utf-8",
    //    headers: { "LanguageGuid": languageuid, "WebsiteGuid": websiteguid, "Cookiedetails": cookiedetails, "SessionGuid": SessionGuid },
    //    success: function (data) {
    //        console.log('ProductHitDone');
    //    },
    //});
}